
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pools/senior",
      function () {
        return require("private-next-pages/pools/senior/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pools/senior"])
      });
    }
  